import {createRoot} from 'react-dom/client';
import type {ReactElement} from 'react';
import {v4 as uuidv4} from 'uuid';
import {isProduction} from '@Libraries/environment-library';

export function renderApp(element: ReactElement<any>, containerId: string = uuidv4()): void {
  if (window.PMW.isReactAppLoaded && !isProduction()) {
    console.error('developer error: an instance of <App /> already exists on this page. Please make sure only one React app is rendered per page.');
  }

  const a = document.createElement('div');
  a.setAttribute('id', containerId);
  document.body.appendChild(a);

  const container = document.getElementById(containerId);
  if (container) {
    const root = createRoot(container);
    root.render(element);
  } else {
    console.error(`Root element with ID '${containerId}' not found.`);
  }
}
